"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_API_KEY = void 0;
const GOOGLE_API_KEY = {
    googleApiKey: 'AIzaSyAM4FAKWvTsmQvv5Mqez1KCDCWOaXEMNtI',
    devGoogleApiKey: 'AIzaSyA0RTGE4ozF8JczDeHCsl8eOxS56It6gwA',
    recaptchaKey: '6LeB6CwUAAAAALm2usHWVLw8uy6346Pg8n63aRpp',
};
exports.GOOGLE_API_KEY = GOOGLE_API_KEY;
//# sourceMappingURL=google.js.map